import React, { useState, useEffect, useContext } from 'react'
// import DeckGL, {FlyToInterpolator} from 'deck.gl';
//import html2canvas from 'html2canvas';

import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import { Alert, AlertTitle } from '@material-ui/lab'
import Tooltip from '@material-ui/core/Tooltip'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Collapse from '@material-ui/core/Collapse'

import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined'
import EditIcon from '@material-ui/icons/Edit'
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import SendIcon from '@material-ui/icons/Send'
import CheckIcon from '@material-ui/icons/Check'

import LogoInf from '../../../../assets/power-line.svg'
import ClearLogo from '../../../../assets/eraser-tool.png'

// import {searchMun} from '../../data/LayerDataApi';
// // import {LayerContext} from '../../../data/AppContext'
// import {LayerContext} from '../../data/AppContext'

import Grow from '@material-ui/core/Grow'

import './download.css'

const useStyles = makeStyles((theme) => ({
  txtContainer: {
    '& label.Mui-focused': {
      color: '#a65e44',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      height: '40px !important',
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px !important',
    },
    width: '250px',
    height: '50px !important',
  },
  circle: {
    color: '#000000',
    opacity: '0.54',
    height: '24px !important',
    width: '24px !important',
    marginLeft: '13px',
    marginTop: '12px',
  },
  head: {
    //borderColor: '#a65e44',
    color: '#8e8e8e',
  },
  tableContainer: {
    border: '1px solid #e0e0e0',
    width: '270px',
    borderBottom: 'none',
  },
  table: {
    width: '100%',
  },
  circle: {
    color: '#a65e44',
  },
  checkbox: {
    color: '#00000080',
    '&.Mui-checked': {
      color: '#a65e44 !important',
    },
  },
}))

function Download(props) {
  const classes = useStyles()

  const [instructionsModal, setInstructionsModal] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [checkedAlert, setCheckedAlert] = useState(true)
  const [tables, setTables] = useState(false)
  const [list, setList] = useState({
    plants: false,
    substations: false,
    lines: false,
    areas: false,
    // regions:false,
    fauna: false,
    hydro: false,
    social: false,
    land: false,
    landmarks: false,
  })

  const [alerta, setAlerta] = useState(false)
  const [temporal, setTemporal] = useState(false)

  const infTable = [
    { lbl: 'Power plants', key: 'plants', border: '1px solid #ddd' },
    { lbl: 'Substations', key: 'substations', border: '1px solid #ddd' },
    { lbl: 'Transmission lines', key: 'lines', border: 'none' },
  ]

  const otherTable = [
    { lbl: 'Protected Areas', key: 'areas', border: '1px solid #ddd' },
    { lbl: 'Geology & Hydrology', key: 'hydro', border: '1px solid #ddd' },
    { lbl: 'Flora & Fauna', key: 'fauna', border: '1px solid #ddd' },
    { lbl: 'Land Ownership', key: 'land', border: '1px solid #ddd' },
    { lbl: 'Archaeology', key: 'landmarks', border: '1px solid #ddd' },
    { lbl: 'Social', key: 'social', border: 'none' },
  ]

  const confirmTable = [
    { lbl: 'Power plants', key: 'plants', border: '1px solid #ddd' },
    { lbl: 'Substations', key: 'substations', border: '1px solid #ddd' },
    { lbl: 'Transmission lines', key: 'lines', border: 'none' },
    { lbl: 'Protected Areas', key: 'areas', border: '1px solid #ddd' },
    // {lbl:'Priority Regions',key:'regions',border:'none'},
    { lbl: 'Geology & Hydrology', key: 'hydro', border: '1px solid #ddd' },
    { lbl: 'Flora & Fauna', key: 'fauna', border: '1px solid #ddd' },
    { lbl: 'Land Ownership', key: 'land', border: '1px solid #ddd' },
    { lbl: 'Archaeology', key: 'landmarks', border: '1px solid #ddd' },
    { lbl: 'Social', key: 'social', border: 'none' },
  ]

  const changeList = (e, key) => {
    const newList = list
    list[key] = e
    setList(newList)
  }

  const toggleOff = () => {
    setList({
      plants: false,
      substations: false,
      lines: false,
      areas: false,
      fauna: false,
      hydro: false,
      social: false,
      land: false,
      landmarks: false,
    })
    // console.log(document.getElementsByName("downloadCB"))
    const elems = document.getElementsByName('downloadCB')
    for (var i = 0; i < elems.length; i++) {
      if (elems[i].checked) elems[i].click()
    }
  }

  const checkedValidation = () => {
    const values = Object.values(list).find((val) => val === true)

    if (values !== undefined) {
      setTables(true)
      // setDownloadPolygon(true)
      // setInstructionsModal(false)
      setCheckedAlert(false)
    }
    if (values === undefined) {
      setTables(false)
      // setDownloadPolygon(true)
      // setInstructionsModal(false)
      setCheckedAlert(true)
    }
  }

  const row = (lbl, border) => {
    return (
      <tr style={{ borderBottom: border, display: 'flex' }}>
        <CheckIcon style={{ marginLeft: '10px', color: '#a65e44', marginRight: '5px' }} />
        <td style={{ display: 'flex' }}>
          <label style={{ margin: '0px', alignSelf: 'center', fontSize: '14px' }}>{lbl}</label>
        </td>
      </tr>
    )
  }

  const confirmRow = (lbl) => {
    return (
      <ListItem divider={true}>
        <ListItemText primary={lbl} />
      </ListItem>
    )
  }

  const clearStates = () => {
    props.delete()
    setInstructionsModal(false)
    setConfirmModal(false)
    props.setProgress(0)
    props.setTableToggle(true)
    props.setSuccess(false)
    props.setError(false)
  }

  function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    )
  }

  CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
  }

  return (
    <div>
      <Grow in={props.menu[4].view}>
        <div className="download-container">
          <div className="download-area">
            <div className="ruler-lbl-container">
              {props.lbl <= 1000 && props.lbl !== 0 ? (
                <label className="distance-txt" style={{ color: '#2f8617' }}>
                  {Intl.NumberFormat('en-US').format(props.lbl.toFixed(2))} km2
                </label>
              ) : props.lbl === 0 ? (
                <label className="distance-txt" style={{ color: '#bbbb' }}>
                  {Intl.NumberFormat('en-US').format(props.lbl.toFixed(2))} km2
                </label>
              ) : (
                <label className="distance-txt" style={{ color: '#e10000' }}>
                  {Intl.NumberFormat('en-US').format(props.lbl.toFixed(2))} km2
                </label>
              )}
            </div>
            <button
              className="ruler-btn"
              style={{ display: 'flex' }}
              onClick={() => {
                // props.delete()
                // props.setPointer('Download Request', true)
                props.setDownload(true)
              }}
            >
              <img src={ClearLogo} className="icon-align-inf" style={{ margin: 'auto', alignSelf: 'center' }} />
            </button>
            <button
              className="ruler-btn"
              style={{ display: 'flex' }}
              disabled={!(props.lbl <= 1000 && props.lbl > 0)}
              onClick={() => {
                setConfirmModal(true)
              }}
            >
              <SendIcon className="icon-align-inf" style={{ margin: 'auto', alignSelf: 'center' }} />
            </button>
          </div>

          <Modal
            open={confirmModal}
            onClose={() =>
              //setConfirmModal(false)
              null
            }
            style={{ display: 'flex' }}
          >
            <div className="instructions-modal">
              <Collapse in={props.tableToggle}>
                <Alert severity="warning">
                  <AlertTitle>Do you want to request this information?</AlertTitle>
                  verify the list below
                </Alert>
                <List dense={true} style={{ marginBottom: '15px' }}>
                  <ListItem style={{ backgroundColor: '#ddd', borderRadius: '5px 5px 0px 0px' }}>
                    <ListItemIcon>
                      <LayersOutlinedIcon style={{ opacity: '0.8' }} />
                    </ListItemIcon>
                    <ListItemText style={{ color: '#8e8e8e' }} primary="Layers" />
                  </ListItem>
                  {confirmTable.map((obj) => (list[obj.key] ? confirmRow(obj.lbl) : null))}
                </List>
                <div style={{ display: 'flex', width: '50%', margin: 'auto' }}>
                  <Button
                    variant="contained"
                    // color="primary"
                    className={classes.button}
                    size="small"
                    // disabled={props.success}
                    // startIcon={<DeleteIcon />}
                    style={{
                      height: '30px',
                      margin: 'auto',
                      background: '#a65e44',
                      color: 'white',
                      alignSelf: 'center',
                    }}
                    onClick={() => {
                      setConfirmModal(false)

                      // setTableToggle(true)
                      // setSuccess(false)
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    // color="primary"
                    className={classes.button}
                    size="small"
                    // disabled={props.success}
                    // startIcon={<EditIcon />}
                    style={{
                      height: '30px',
                      margin: 'auto',
                      background: '#a65e44',
                      color: 'white',
                      alignSelf: 'center',
                    }}
                    onClick={() => {
                      props.uploadFile(list)
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </Collapse>
              <Collapse in={props.success}>
                <Alert style={{ marginBottom: '15px' }} severity="success">
                  <AlertTitle>Successful request</AlertTitle>
                  Your application was sent to the Tycho team.
                </Alert>
                <div style={{ display: 'flex', width: '50%', margin: 'auto' }}>
                  <Button
                    variant="contained"
                    // color="primary"
                    className={classes.button}
                    size="small"
                    // disabled={props.tableToggle}
                    // startIcon={<EditIcon />}
                    style={{
                      height: '30px',
                      margin: 'auto',
                      background: '#a65e44',
                      color: 'white',
                      alignSelf: 'center',
                    }}
                    onClick={() => {
                      props.delete()
                      toggleOff()
                      setConfirmModal(false)
                      clearStates()
                    }}
                  >
                    Close
                  </Button>
                </div>
              </Collapse>

              <Collapse in={props.error.flag}>
                <Alert style={{ marginBottom: '15px' }} severity="error">
                  <AlertTitle>Error</AlertTitle>
                  {props.error.message}
                </Alert>
                <div style={{ display: 'flex', width: '50%', margin: 'auto' }}>
                  <Button
                    variant="contained"
                    // color="primary"
                    className={classes.button}
                    size="small"
                    // disabled={props.tableToggle}
                    // startIcon={<EditIcon />}
                    style={{
                      height: '30px',
                      margin: 'auto',
                      background: '#a65e44',
                      color: 'white',
                      alignSelf: 'center',
                    }}
                    onClick={() => {
                      props.delete()
                      toggleOff()
                      setConfirmModal(false)
                      clearStates()
                    }}
                  >
                    Close
                  </Button>
                </div>
              </Collapse>

              <div style={{ display: 'flex', width: '40px', margin: 'auto', marginTop: '15px' }}>
                <CircularProgressWithLabel
                  className={classes.circle}
                  variant="determinate"
                  value={props.progress}
                  // value={100}
                />
              </div>
            </div>
          </Modal>

          <Modal
            open={instructionsModal}
            onClose={
              () => null
              // setInstructionsModal(false)
              // setDownloadPolygon(false)
            }
            style={{ display: 'flex' }}
          >
            <div className="instructions-modal">
              <IconButton
                onClick={() => {
                  setInstructionsModal(false)
                  //setDownloadPolygon(false)
                }}
                size="small"
                style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
              >
                <CloseIcon />
              </IconButton>
              <h3 style={{ marginTop: '0px' }}>Draw a Polygon</h3>
              <div style={{ width: '100%', marginBottom: '100px' }}>
                {/*<div style={{width:'45%',backgroundColor:'#bbb',height:'100%',borderRadius:'5px',padding:'15px',marginRight:'5%'}}>
                <p style={{fontSize:'14px',textAlign:'justify',margin:'0px'}}>Draw a polygon of 1,000 km2 within the layers you are interested. 
                   Please verify the table to the right before continuing. </p>
                </div>*/}
                <Collapse in={checkedAlert}>
                  <Alert style={{ marginBottom: '15px' }} severity="warning">
                    Select one or more layers prior to proceeding.
                  </Alert>
                </Collapse>

                <Collapse in={tables}>
                  <div style={{ width: '100%' }}>
                    <table className="modal-table">
                      <tr>
                        <th className="modal-table-header">
                          <img className="table-img" src={LogoInf} />
                          <label style={{ alignSelf: 'center' }}>Infrastructure</label>
                        </th>
                      </tr>
                      {infTable.map((obj) => (list[obj.key] ? row(obj.lbl, obj.border) : null))}
                    </table>

                    {/*<table className='modal-table'>
                    <tr>
                      <th className='modal-table-header'>
                        
                         <img className='table-img' src={LogoAreas}/>
                          <a style={{alignSelf:'center'}}>Land Use & Environmental Protection</a>
                          
                      </th>
                    </tr>
                    {areaTable.map(obj => 
                       ( list[obj.key] ? row(obj.lbl,obj.border): null)
                      )}
                  </table>*/}

                    <table className="modal-table">
                      <tr>
                        <th className="modal-table-header">
                          <LayersOutlinedIcon className="table-img" style={{ opacity: '0.8' }} />
                          <label style={{ alignSelf: 'center' }}>Other</label>
                        </th>
                      </tr>
                      {otherTable.map((obj) => (list[obj.key] ? row(obj.lbl, obj.border) : null))}
                    </table>

                    <div style={{ display: 'flex', width: '50%', margin: 'auto' }}>
                      <Button
                        variant="contained"
                        // color="primary"
                        className={classes.button}
                        size="small"
                        // startIcon={<DeleteIcon />}
                        style={{
                          height: '30px',
                          margin: 'auto',
                          background: '#a65e44',
                          color: 'white',
                          alignSelf: 'center',
                        }}
                        onClick={() => {
                          //setDownloadPolygon(false)
                          props.setPointer('Download', false)
                          setInstructionsModal(false)
                        }}
                      >
                        Cancel
                      </Button>

                      <Button
                        variant="contained"
                        // color="primary"
                        className={classes.button}
                        size="small"
                        // startIcon={<EditIcon />}
                        style={{
                          height: '30px',
                          margin: 'auto',
                          background: '#a65e44',
                          color: 'white',
                          alignSelf: 'center',
                        }}
                        onClick={() => {
                          props.setDownload(true)
                          setInstructionsModal(false)
                        }}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </Collapse>
              </div>
              <div className="download-modal-footer">
                <div>
                  <p
                    style={{
                      fontSize: '12px',
                      padding: '15px 15px 0px 15px',
                      margin: '0px',
                    }}
                  >
                    <b>Download limits:</b> 3 download requests per month | 1,000 km2 area
                  </p>
                </div>
                <div>
                  <p
                    style={{
                      fontSize: '12px',
                      padding: '15px 15px 0px 15px',
                      margin: '0px',
                    }}
                  >
                    Draw a polygon of 1,000 km2 within the layers you are interested. Please verify the table above
                    before continuing.
                  </p>
                </div>
              </div>
            </div>
          </Modal>

          <div className="download-header">
            <label className="download-title">Download Tool</label>
          </div>

          <div className="tables-container">
            <div className="download-radius-top">
              <div className="table-header">
                <img className="table-img" src={LogoInf} />
                <label style={{ alignSelf: 'center' }}>Infrastructure</label>
              </div>

              <div className="table-rows">
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'plants')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Power plants</label>
                </div>
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'substations')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Substations</label>
                </div>
              </div>
              <div className="table-rows">
                <Checkbox
                  name="downloadCB"
                  color="primary"
                  size="small"
                  className={classes.checkbox}
                  style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                  onChange={(e) => {
                    changeList(e.target.checked, 'lines')
                  }}
                />
                <label style={{ alignSelf: 'center' }}>Transmission lines</label>
              </div>
            </div>

            <div className="download-radius-bottom">
              <div className="table-header">
                <LayersOutlinedIcon className="table-img" style={{ opacity: '0.8' }} />
                <label style={{ alignSelf: 'center' }}>Other</label>
              </div>

              <div className="table-rows">
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'hydro')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Geology & Hydrology</label>
                </div>
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'fauna')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Flora & Fauna</label>
                </div>
              </div>
              <div className="table-rows">
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'land')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Land Ownership</label>
                </div>
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'landmarks')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Archaeology</label>
                </div>
              </div>
              <div className="table-rows">
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'social')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Social</label>
                </div>
                <div style={{ display: 'flex', width: '170px' }}>
                  <Checkbox
                    name="downloadCB"
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    style={{ padding: '0px', marginRight: '5px', alignSelf: 'center', marginLeft: '10px' }}
                    onChange={(e) => {
                      changeList(e.target.checked, 'areas')
                    }}
                  />
                  <label style={{ alignSelf: 'center' }}>Protected Areas</label>
                </div>
              </div>
            </div>

            <div className="table-rows" style={{ height: '45px' }}>
              <Button
                variant="contained"
                color="default"
                //className={classes.button}
                size="small"
                startIcon={<DeleteIcon />}
                style={{ height: '30px', margin: 'auto' }}
                onClick={() => {
                  // downloadLayers([]);
                  // setDownload([]);
                  props.setDownload(false)
                  toggleOff()
                }}
              >
                Delete
              </Button>

              <Button
                variant="contained"
                color="default"
                className={classes.button}
                size="small"
                startIcon={<EditIcon />}
                style={{ height: '30px', margin: 'auto' }}
                onClick={() => {
                  setInstructionsModal(true)
                  checkedValidation()
                }}
              >
                Draw
              </Button>
            </div>

            <div></div>
            <div></div>
          </div>

          <Collapse in={alerta}>
            <Alert severity="error" style={{ zIndex: '10' }}>
              Facility not found
            </Alert>
          </Collapse>
        </div>
      </Grow>
    </div>
  )
}

export default Download
